import * as React from "react"
import { ChevronDownIcon } from "lucide-react"
import { format } from "date-fns"
import { Button } from "@/Components/ui/button"
import { Calendar } from "@/Components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/Components/ui/popover"
import { cn } from "@/lib/utils"

export function DatePicker({ 
  value, 
  onChange, 
  placeholder = "Pick a date",
  disabled,
  minDate,
  className,
  id,
  ...props 
}) {
  const [open, setOpen] = React.useState(false)
  const [date, setDate] = React.useState(value ? new Date(value) : undefined)

  React.useEffect(() => {
    if (value) {
      const newDate = new Date(value)
      if (!isNaN(newDate.getTime())) {
        setDate(newDate)
      }
    } else {
      setDate(undefined)
    }
  }, [value])

  const handleDateSelect = (selectedDate) => {
    if (selectedDate) {
      setDate(selectedDate)
      // Format as YYYY-MM-DD for the form value
      const formatted = format(selectedDate, "yyyy-MM-dd")
      onChange?.(formatted)
      setOpen(false)
    }
  }

  const displayValue = date ? date.toLocaleDateString() : placeholder

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          id={id}
          variant="outline"
          className={cn(
            "w-full justify-between font-normal",
            !date && "text-muted-foreground",
            className
          )}
          disabled={disabled}
          {...props}
        >
          {displayValue}
          <ChevronDownIcon className="h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto overflow-hidden p-0" align="start">
        <Calendar
          mode="single"
          selected={date}
          captionLayout="dropdown"
          disabled={minDate ? (date) => date < new Date(minDate) : undefined}
          onSelect={handleDateSelect}
        />
      </PopoverContent>
    </Popover>
  )
}
